import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function FooterCTA() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-charcoal text-cream/60 py-12 px-4 text-center text-sm" data-id="element-19">
        <div className="max-w-4xl mx-auto" data-id="element-20">
          <p className="mb-6" data-id="element-21">
            "El Reinicio de 72 Horas" es una guía digital diseñada para
            proporcionar herramientas de bienestar. No sustituye el consejo
            médico profesional, diagnóstico o tratamiento.
          </p>
          <div className="flex justify-center gap-6 mb-6" data-id="element-22">
            <button onClick={() => setActiveModal('terms')} className="hover:text-cream transition-colors cursor-pointer underline-offset-2 hover:underline" data-id="element-23">
              Términos y Condiciones
            </button>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-cream transition-colors cursor-pointer underline-offset-2 hover:underline" data-id="element-24">
              Política de Privacidad
            </button>
          </div>
          <p data-id="element-25">
            © {new Date().getFullYear()} El Reinicio de 72 Horas. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-charcoal/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-26">
          <div className="bg-cream rounded-3xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto relative" style={{
        animation: 'fadeInUp 0.4s ease-out'
      }} onClick={e => e.stopPropagation()} data-id="element-27">
            <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 p-2 rounded-full hover:bg-sage transition-colors text-teal" data-id="element-28">
              <X className="w-5 h-5" data-id="element-29" />
            </button>

            <div className="p-8 md:p-12" data-id="element-30">
              {activeModal === 'terms' && <TermsContent data-id="element-31" />}
              {activeModal === 'privacy' && <PrivacyContent data-id="element-32" />}
            </div>
          </div>
        </div>}
    </>;
}
function TermsContent() {
  return <div className="space-y-6 text-charcoal" data-id="element-33">
      <h2 className="text-3xl font-serif text-teal" data-id="element-34">Términos y Condiciones</h2>
      <p className="text-sm text-charcoal/60" data-id="element-35">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>
      <div className="space-y-4 text-sm leading-relaxed" data-id="element-36">
        <h3 className="text-lg font-serif text-teal" data-id="element-37">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-38">
          Al adquirir y utilizar "El Reinicio de 72 Horas", aceptas estos
          términos y condiciones en su totalidad. Si no estás de acuerdo con
          alguno de estos términos, te pedimos que no realices la compra.
        </p>

        <h3 className="text-lg font-serif text-teal" data-id="element-39">
          2. Descripción del Producto
        </h3>
        <p data-id="element-40">
          "El Reinicio de 72 Horas" es un producto digital (guía en formato PDF)
          diseñado para proporcionar herramientas de bienestar y manejo del
          estrés. No constituye asesoramiento médico, psicológico ni profesional
          de salud.
        </p>

        <h3 className="text-lg font-serif text-teal" data-id="element-41">3. Uso del Producto</h3>
        <p data-id="element-42">
          El contenido es para uso personal y no comercial. Queda prohibida la
          reproducción, distribución o reventa del material sin autorización
          expresa por escrito.
        </p>

        <h3 className="text-lg font-serif text-teal" data-id="element-43">
          4. Política de Reembolso
        </h3>
        <p data-id="element-44">
          Debido a la naturaleza digital del producto y su entrega inmediata,
          todas las ventas son finales. No se ofrecen reembolsos una vez
          completada la descarga.
        </p>

        <h3 className="text-lg font-serif text-teal" data-id="element-45">
          5. Limitación de Responsabilidad
        </h3>
        <p data-id="element-46">
          Los resultados pueden variar de persona a persona. No garantizamos
          resultados específicos. Este producto no sustituye el tratamiento
          médico o psicológico profesional. Si experimentas una crisis de salud
          mental, busca ayuda profesional inmediata.
        </p>

        <h3 className="text-lg font-serif text-teal" data-id="element-47">
          6. Propiedad Intelectual
        </h3>
        <p data-id="element-48">
          Todo el contenido, incluyendo textos, gráficos y metodologías, está
          protegido por derechos de autor. El uso no autorizado puede resultar
          en acciones legales.
        </p>

        <h3 className="text-lg font-serif text-teal" data-id="element-49">7. Modificaciones</h3>
        <p data-id="element-50">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor inmediatamente después
          de su publicación.
        </p>
      </div>
    </div>;
}
function PrivacyContent() {
  return <div className="space-y-6 text-charcoal" data-id="element-51">
      <h2 className="text-3xl font-serif text-teal" data-id="element-52">Política de Privacidad</h2>
      <p className="text-sm text-charcoal/60" data-id="element-53">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>
      <div className="space-y-4 text-sm leading-relaxed" data-id="element-54">
        <h3 className="text-lg font-serif text-teal" data-id="element-55">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-56">
          Al realizar tu compra, recopilamos únicamente la información necesaria
          para procesar tu pedido: nombre, dirección de correo electrónico e
          información de pago. No almacenamos datos de tarjetas de crédito
          directamente.
        </p>

        <h3 className="text-lg font-serif text-teal" data-id="element-57">
          2. Uso de la Información
        </h3>
        <p data-id="element-58">
          Tu información personal se utiliza exclusivamente para: procesar y
          entregar tu compra, enviarte el producto digital adquirido, y
          comunicarnos contigo sobre tu pedido si es necesario.
        </p>

        <h3 className="text-lg font-serif text-teal" data-id="element-59">3. Protección de Datos</h3>
        <p data-id="element-60">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración, divulgación o destrucción.
        </p>

        <h3 className="text-lg font-serif text-teal" data-id="element-61">
          4. Compartir Información
        </h3>
        <p data-id="element-62">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros. La única excepción son los proveedores de servicios de pago
          necesarios para procesar tu transacción.
        </p>

        <h3 className="text-lg font-serif text-teal" data-id="element-63">5. Cookies</h3>
        <p data-id="element-64">
          Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
          navegación. Puedes configurar tu navegador para rechazar cookies,
          aunque esto podría afectar la funcionalidad del sitio.
        </p>

        <h3 className="text-lg font-serif text-teal" data-id="element-65">6. Tus Derechos</h3>
        <p data-id="element-66">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento. También puedes solicitar la
          portabilidad de tus datos o retirar tu consentimiento para el
          procesamiento de los mismos.
        </p>

        <h3 className="text-lg font-serif text-teal" data-id="element-67">
          7. Cambios en esta Política
        </h3>
        <p data-id="element-68">
          Nos reservamos el derecho de actualizar esta política de privacidad en
          cualquier momento. Te notificaremos sobre cambios significativos a
          través del correo electrónico proporcionado.
        </p>
      </div>
    </div>;
}